module.exports = __webpack_public_path__ + "img/emoji_85.6eec72eb.png";